<template>
<div class="styled-radio-container styled-radio-container--ou-donation row">
  <div v-for="[amount, description] of amounts" :key="amount" class="amount-row single-amount__row">
    <input :id="`amount${amount}`" type="radio" class="amount" @click="selectedAmount = amount" :checked="selectedAmount == amount">
    <FormLabel :for="`amount${amount}`">
      <MoneyFormat class="label-amount" :value="amount" :currencyCode="form.currency" :hide-subunits="true" />
      <span class="label-description">{{description}}</span>
    </FormLabel>	  
  </div>
  
  <div class="amount_other__wrapper amount-row">
      <input id="amount_other_check" type="radio" class="amount" :checked="customSelected" @click="customSelected = true">
      <input type="number" min="1" name="amount_other" placeholder="Other amount" v-model="customAmount" />
  </div>
</div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  type PropType,
  ref,
  watch,
} from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

import type { Currency } from '~/form-settings'

export default defineComponent({  setup() {
    const { setValue, form, settings } = usePaymentForm()

    const selectedAmount = ref()
    const customAmount = ref(form.value.amount)
    const customSelected = ref(false)

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customSelected.value = false

        customAmount.value = null

        setValue('amount', '' + selectedAmount)
      }
    })

    watch(customSelected, (customSelected) => {
      if (customSelected) {
        selectedAmount.value = null
        setValue('amount', null)
      }
    })

    watch(customAmount, (customAmount) => {
      if (customAmount) {
        selectedAmount.value = null
        customSelected.value = true
      }

      if (!selectedAmount.value) setValue('amount', customAmount || null)
    })

    function clearOutSelectedValue() {
      selectedAmount.value = null
      setValue('amount', null)
    }

    const amounts = computed(() => {
      const amounts = settings!.amounts! as
        | [number, string][]
        | [Partial<{ [key in Currency]: number }>, string][]

      if (typeof amounts[0][0] == 'number') return amounts

      return (amounts as [
        Partial<{ [key in Currency]: number }>,
        string
      ][]).map(([amounts, label]) => [amounts[form.value.currency!], label])
    })

    return {
      form,
      amounts,
      selectedAmount,
      customAmount,
      clearOutSelectedValue,
      customSelected,
    }
  },
})
</script>
<style scoped lang="scss">
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  // display: flex;
  // flex-wrap: wrap;
  width: 100%;
  // justify-content: space-between;

  // input[type='radio'] {
  //   height: 0;
  //   top: 20px;
  //   position: absolute;
  //   left: 20px;
  //   z-index: -1;
  //   visibility: hidden;
  // }
  label {
    font-weight: bold;
    text-align: left;
    width: 100%;
    cursor: pointer;
    display: flex;
    height: 100%;
    align-items: center;
    overflow: hidden;
    padding: 6px 0px 6px 5px;
  }
  .amount_other__wrapper {
    position: relative;
    min-width: 22%;
    overflow: hidden;
    max-width: 50%;
    // border: 2px solid #f3ebcf;
    // border-radius: 4px;
    // padding-left: 5px;
    // flex: 1;
    // line-height: 1;
    @media (max-width: 720px) {
      max-width: 100%;
    }
    &:before {
      content: '$';
      position: absolute;
      padding: 15px 8px;
      border-right: 1px solid #f3ebcf;
      height: 100%;
      background: white;
      text-align: center;
      top: 0px;
      left: 0;
      width: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:after {
      display: none !important;
    }
    input[type='number'] {
      border: none;
      background: #fff;
      margin-left: 70px;
      box-shadow: none;
      max-width: 85%;
    }
  }
}
.amount-row {
    display: flex;
    border: 2px solid #00adef;
    align-items: center;
    width: 100%;
    padding-left: 15px;
    margin-bottom: 13px;
    border-radius: 6px;
    &.single-amount__row:hover{
    background-color: #00adef;
      color: #fff;
      .label-amount,
      .label-description{
         color: #fff;
      }
    }    
}
.label-amount {
  font-weight: bold;
  padding: 10px;
  display: inline-block;
      color: #00507d;
  letter-spacing: 0;
  font-size: 18px;
}
.label-description {
  font-weight: normal;
  padding: 0px;
  font-size: 16px;
  color: #00507d;
  align-items: center;
  justify-content: center;
  display: flex;
  line-height: 1.4;
}
</style>